(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-section"] && !Shopify.designMode) return;
  try {
    
  function setHomepageFaqState(button, open) {
    if (button.getAttribute('aria-expanded') === String(open)) return;
    const answer = button.nextElementSibling;
    const height = answer.getBoundingClientRect().height;
    const opacity = answer.hidden ? 0 : getComputedStyle(answer).opacity;
    const margin = answer.hidden ? '0px' : getComputedStyle(answer).marginTop;
    if (answer.faqAnimation) answer.faqAnimation.cancel();
    button.setAttribute('aria-expanded', String(open));
    answer.inert = !open;
    answer.setAttribute('aria-hidden', String(!open));
    answer.hidden = false;
    if (!answer.animate || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      answer.hidden = !open;
      return;
    }
    const animation = answer.animate([
      { height: height + 'px', opacity, marginTop: margin },
      { height: open ? answer.scrollHeight + 'px' : '0px', opacity: open ? 1 : 0, marginTop: open ? getComputedStyle(answer).marginTop : '0px' }
    ], { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    answer.faqAnimation = animation;
    animation.onfinish = () => {
      answer.hidden = !open;
      answer.faqAnimation = null;
    };
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.merox-faq-question');
    if (!button) return;
    const open = button.getAttribute('aria-expanded') !== 'true';
    const homepage = button.closest('[data-homepage-faq]');
    if (homepage) {
      homepage.querySelectorAll('.merox-faq-question').forEach((other) => {
        setHomepageFaqState(other, other === button && open);
      });
    } else {
      button.setAttribute('aria-expanded', String(open));
      button.nextElementSibling.hidden = !open;
      button.querySelector('.merox-faq-icon').textContent = open ? '−' : '+';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
